import { defineStore } from 'pinia'


export const useHealthSeekersStore = defineStore('healthSeekers', {
  state: () => ({
    healthSeekers: [],
    healthSeeker: null,
  }),
  actions: {
    setHealthSeeker(healthSeeker: any) {
      this.healthSeeker = healthSeeker
    },

    setHealthSeekers(healthSeekers: any) {
      this.healthSeekers = healthSeekers
    },
    
    resetStore() {
      this.healthSeeker = null
      this.healthSeekers = []
    }
  },

  getters: {
    getHealthSeeker: (state) => state.healthSeeker,
    getHealthSeekers: (state) => state.healthSeekers,
  }

})